<template>
  <div
    class="with-indicator"
    :class="bem('with-indicator', { appearance })"
  >
    <div
      v-if="visible && position === 'left'"
      class="with-indicator__indicator"
    />
    <div class="with-indicator__content">
      <slot />
    </div>
    <div
      v-if="visible && position === 'right'"
      class="with-indicator__indicator"
    />
  </div>
</template>

<script>
  import { bem } from "src/utils/bem.js";

  export default {
    name: 'WithIndicator',
    props: {
      visible: Boolean,
      position: {
        type: String,
        default: 'right',
      },
      appearance: String,
    },
    methods: {
      bem,
    }
  }
</script>